import functions from '../../services/functions'
import device from '../../api/device'
import {
  GET_CAMERA_REQUEST,
  GET_CAMERA_SUCCESS,
  GET_CAMERA_FAILURE,
  GET_CAMERA_LIVESNAPSHOT_REQUEST,
  GET_CAMERA_LIVESNAPSHOT_SUCCESS,
  GET_CAMERA_LIVESNAPSHOT_FAILURE,
  GET_CAMERA_THUMBNAILVIDEOS_REQUEST,
  GET_CAMERA_THUMBNAILVIDEOS_SUCCESS,
  GET_CAMERA_THUMBNAILVIDEOS_FAILURE,
  GET_CAMERA_THUMBNAILVIDEO_SUCCESS
} from '../mutation-types'

// initial state
const state = {
  cameras: {},
  liveSnapshot: {},
  thumbnailVideos: {},
  status: {
    getCamera: {},
    getLiveSnapshot: {},
    getThumbnailVideo: {},
    getThumbnailVideos: {}
  }
}

// getters
const getters = {
  camera: function (state) {
    return function (cameraId) {
      return state.cameras[cameraId]
    }
  },
  thumbnailVideo: function (state) {
    return function (thumbnailVideoId) {
      return state.thumbnailVideos[thumbnailVideoId]
    }
  },
  liveSnapshot: function (state) {
    return function (cameraId) {
      return state.liveSnapshot[cameraId]
    }
  },
  statusGetLiveSnapshot: function (state) {
    return function (cameraId) {
      return state.status.getLiveSnapshot[cameraId]
    }
  }
}

// actions
const actions = {
  getThumbnailVideos: function ({commit, getters, dispatch}, {cameraId}) {
    return new Promise((resolve, reject) => {
      commit(GET_CAMERA_THUMBNAILVIDEOS_REQUEST, {cameraId: cameraId})
      let stime = 0
      let etime = +getters.site(getters.camera(cameraId).siteId).todayDateId() + 60 * 60 * 24
      device.getThumbnailVideos(getters.camera(cameraId).siteId, cameraId, stime, etime).then(
        res => {
          if (res.body instanceof Object) {
            if (functions.hasAllKeys(res.body, [
              'count',
              'thumbnails'
            ])) {
              if (res.body.thumbnails instanceof Array) {
                let thumbnailVideos = {}
                res.body.thumbnails.map(thumbnail => {
                  let isDataValid = false
                  if (functions.hasAllKeys(thumbnail, [
                    'duration_time',
                    'thumbnail_records',
                    'timestamp',
                    'url'
                  ])) {
                    let dateId = thumbnail.timestamp
                    let timeDiff = +getters.site(getters.camera(cameraId).siteId).todayDateId() - dateId
                    if (timeDiff % (60 * 60 * 24) === 0) {
                      if (thumbnail.thumbnail_records instanceof Object) {
                        if (functions.hasAllKeys(thumbnail.thumbnail_records, [
                          'count'
                        ])) {
                          isDataValid = true
                        }
                      }
                    } else console.log('incorrect timestamp')
                    if (isDataValid) {
                      let thumbnailVideoId = cameraId + '-' + dateId
                      thumbnailVideos[dateId] = thumbnailVideoId
                      // console.log(timeDiff / 60 / 60 / 24 + ' days ago')
                      commit(GET_CAMERA_THUMBNAILVIDEO_SUCCESS, {
                        thumbnailVideoId: thumbnailVideoId,
                        thumbnailVideo: {
                          thumbnailVideoId: thumbnailVideoId,
                          dateId: dateId,
                          url: thumbnail.url,
                          isThumbnailVideoCreated: thumbnail.url ? 1 : 0,
                          hasMissingThumbnail: thumbnail.thumbnail_records.count !== 1440 ? 1 : 0,
                          hasThumbnailRecords: thumbnail.thumbnail_records.count ? 1 : 0,
                          thumbnailRecords: thumbnail.thumbnail_records
                        }
                      })
                    }
                  }
                })
                commit(GET_CAMERA_THUMBNAILVIDEOS_SUCCESS, {
                  cameraId: cameraId,
                  thumbnailVideos: thumbnailVideos
                })
              } else {
                console.log('getThumbnailVideos failed')
                commit(GET_CAMERA_THUMBNAILVIDEOS_FAILURE, {cameraId: cameraId})
                reject({
                  status: res.status,
                  statusText: res.statusText,
                  body: res.body,
                  successButText: 'incorrect api response'
                })
              }
            } else {
              console.log('getThumbnailVideos failed')
              commit(GET_CAMERA_THUMBNAILVIDEOS_FAILURE, {cameraId: cameraId})
              reject({
                status: res.status,
                statusText: res.statusText,
                body: res.body,
                successButText: 'incorrect api response'
              })
            }
          } else {
            console.log('getThumbnailVideos failed')
            commit(GET_CAMERA_THUMBNAILVIDEOS_FAILURE, {cameraId: cameraId})
            reject({
              status: res.status,
              statusText: res.statusText,
              body: res.body,
              successButText: 'incorrect api response'
            })
          }
        },
        err => {
          console.log(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_CAMERA_THUMBNAILVIDEOS_FAILURE, {cameraId: cameraId})
          reject({
            status: err.status,
            statusText: err.statusText,
            body: err.body
          })
        }
      )
    })
  },
  getSiteCamera: function ({commit, getters, dispatch}, cameraId) {
    return new Promise((resolve, reject) => {
      commit(GET_CAMERA_REQUEST, {cameraId: cameraId})
      device.getSiteCamera(getters.camera(cameraId).siteId, cameraId).then(
        res => {
          if (res.body[0] instanceof Object) {
            if (functions.hasAllKeys(res.body[0], [
              'device_id',
              'alarm_zone',
              'trouble_zone',
              'name',
              'mac',
              'type',
              'channel',
              'model',
              'is_privacy',
              'privacy_disabled_duration',
              'privacy_disabled_timestamp',
              'is_activated',
              'is_online',
              'is_online_update_time',
              'is_cont_recording',
              'firmware_update_status',
              'is_registered',
              'position_metadata',
              'privacy_background_image_url',
              'private_ip',
              'public_ip',
              'stream_url'
            ])) {
              commit(GET_CAMERA_SUCCESS, {
                siteId: getters.camera(cameraId).siteId,
                cameraId: res.body[0].device_id,
                alarmZone: res.body[0].alarm_zone,
                troubleZone: res.body[0].trouble_zone,
                name: res.body[0].name,
                mac: res.body[0].mac,
                type: res.body[0].type,
                channel: res.body[0].channel,
                model: res.body[0].model,
                isPrivacyEnabled: res.body[0].is_privacy,
                privacyDisabledDuration: res.body[0].privacy_disabled_duration,
                privacyDisabledTimestamp: res.body[0].privacy_disabled_timestamp,
                isActivated: res.body[0].is_activated,
                isOnline: res.body[0].is_online,
                isOnlineUpdatedAt: res.body[0].is_online_update_time,
                isContinuousRecordingEnabled: res.body[0].is_cont_recording,
                firmwareUpdateStatus: res.body[0].firmware_update_status,
                isRegistered: res.body[0].is_registered,
                positionMetadata: res.body[0].position_metadata,
                privacyBackgroundImageUrl: res.body[0].privacy_background_image_url,
                privateIp: res.body[0].private_ip,
                publicIp: res.body[0].public_ip,
                videoStreamUrl: res.body[0].stream_url
              })
              resolve()
            } else {
              console.log('getSiteCamera failed')
              commit(GET_CAMERA_FAILURE, {cameraId: cameraId})
              reject({
                status: res.status,
                statusText: res.statusText,
                body: res.body,
                successButText: 'incorrect api response'
              })
            }
          } else {
            console.log('getSiteCamera failed')
            commit(GET_CAMERA_FAILURE, {cameraId: cameraId})
            reject({
              status: res.status,
              statusText: res.statusText,
              body: res.body,
              successButText: 'incorrect api response'
            })
          }
          dispatch('checkOnlineStatusByApiResponse', res)
        },
        err => {
          console.log(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_CAMERA_FAILURE, {cameraId: cameraId})
          reject({
            status: err.status,
            statusText: err.statusText,
            body: err.body
          })
        }
      )
    })
  },
  getLiveSnapshot: function ({commit, getters, dispatch}, cameraId) {
    return new Promise((resolve, reject) => {
      commit(GET_CAMERA_LIVESNAPSHOT_REQUEST, {cameraId: cameraId})
      device.getLiveSnapshot(getters.camera(cameraId).siteId, cameraId).then(
        res => {
          if (res.body instanceof Object) {
            if (functions.hasAllKeys(res.body, [
              'data',
              'timestamp'
            ])) {
              commit(GET_CAMERA_LIVESNAPSHOT_SUCCESS, {
                cameraId: cameraId,
                liveSnapshot: {
                  url: 'data:image/jpg;base64,' + res.body.data,
                  timestamp: res.body.timestamp
                }
              })
              resolve()
            } else {
              console.log('getLiveSnapshot failed')
              commit(GET_CAMERA_LIVESNAPSHOT_FAILURE, {cameraId: cameraId})
              reject({
                status: res.status,
                statusText: res.statusText,
                body: res.body,
                successButText: 'incorrect api response'
              })
            }
          } else {
            console.log('getLiveSnapshot failed')
            commit(GET_CAMERA_LIVESNAPSHOT_FAILURE, {cameraId: cameraId})
            reject({
              status: res.status,
              statusText: res.statusText,
              body: res.body,
              successButText: 'incorrect api response'
            })
          }
          dispatch('checkOnlineStatusByApiResponse', res)
        },
        err => {
          console.log(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_CAMERA_LIVESNAPSHOT_FAILURE, {cameraId: cameraId})
          reject({
            status: err.status,
            statusText: err.statusText,
            body: err.body
          })
        }
      )
    })
  }
}

// mutations
const mutations = {
  [GET_CAMERA_REQUEST]: function (state, data) {
    state.status.getCamera = {...state.status.getCamera, [data.cameraId]: 'requested'}
  },
  [GET_CAMERA_SUCCESS]: function (state, data) {
    state.status.getCamera = {...state.status.getCamera, [data.cameraId]: 'successful'}
    state.cameras = {...state.cameras, [data.cameraId]: data}
  },
  [GET_CAMERA_FAILURE]: function (state, data) {
    state.status.getCamera = {...state.status.getCamera, [data.cameraId]: 'failed'}
  },
  [GET_CAMERA_LIVESNAPSHOT_REQUEST]: function (state, data) {
    state.status.getLiveSnapshot = {...state.status.getLiveSnapshot, [data.cameraId]: 'requested'}
  },
  [GET_CAMERA_LIVESNAPSHOT_SUCCESS]: function (state, data) {
    state.status.getLiveSnapshot = {...state.status.getLiveSnapshot, [data.cameraId]: 'successful'}
    state.liveSnapshot = {...state.liveSnapshot, [data.cameraId]: data.liveSnapshot}
    // state.liveSnapshot[data.cameraId] = data.liveSnapshot
  },
  [GET_CAMERA_LIVESNAPSHOT_FAILURE]: function (state, data) {
    state.status.getLiveSnapshot = {...state.status.getLiveSnapshot, [data.cameraId]: 'failed'}
  },
  [GET_CAMERA_THUMBNAILVIDEOS_REQUEST]: function (state, data) {
    state.status.getThumbnailVideos = {...state.status.getThumbnailVideos, [data.cameraId]: 'requested'}
  },
  [GET_CAMERA_THUMBNAILVIDEOS_SUCCESS]: function (state, data) {
    state.status.getThumbnailVideos = {...state.status.getThumbnailVideos, [data.cameraId]: 'successful'}
    state.cameras[data.cameraId] = {...state.cameras[data.cameraId], thumbnailVideos: data.thumbnailVideos}
  },
  [GET_CAMERA_THUMBNAILVIDEOS_FAILURE]: function (state, data) {
    state.status.getThumbnailVideos = {...state.status.getThumbnailVideos, [data.cameraId]: 'failed'}
  },
  [GET_CAMERA_THUMBNAILVIDEO_SUCCESS]: function (state, data) {
    state.status.getThumbnailVideo = {...state.status.getThumbnailVideo, [data.thumbnailVideoId]: 'successful'}
    state.thumbnailVideos = {...state.thumbnailVideos, [data.thumbnailVideoId]: data.thumbnailVideo}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cameras.js